import { useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Modal, Paper, Select, Stack, TextField, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { COUNTRIES } from '../../util/Constants';

const formControlStyle = { width: '90%', margin: 'auto', marginBottom: '16px' };

function EditHospital({handleCloseModal, hospital, handleSaveChange, isNew}) {

  const [hospitalName, setHospitalName] = useState(hospital.name || '');
  const [hospitalCountry, setHospitalCountry] = useState(hospital.country || '');
  const [requiresMFA, setRequiresMFA] = useState(hospital.requiresMFA || false);

  const handleSave = () => {
    handleSaveChange({
      hospitalId: hospital.id || '',
      hospitalName,
      hospitalCountry,
      requiresMFA
    });
    handleCloseModal();
  };

  return (
    <Modal open={true} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Paper
        sx={{
          padding: '16px',
          position: 'absolute',
          minWidth: '550px',

          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          component="h3"
          sx={{
            fontSize: '1.5em',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          {isNew ? 'Add Hospital' : 'Edit Hospital' }
        </Typography>
        { hospital ?
          <>
            <TextField sx={formControlStyle} variant="standard" label="Name" value={hospitalName} onChange={(event) => setHospitalName(event.target.value)} />
            <FormControl sx={formControlStyle} variant="standard">
              <InputLabel>Country</InputLabel>
              <Select value={hospitalCountry} onChange={(event) => setHospitalCountry(event.target.value)}>
                {COUNTRIES.map(({ name, code }) => (
                  <MenuItem key={name} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ ...formControlStyle, display: 'inline' }}>
              <FormControlLabel control={<Checkbox onChange={(event) => setRequiresMFA(event.target.checked)} checked={requiresMFA} />} label="Requires MFA" />
            </FormControl>
            <Stack direction="row" justifyContent="flex-end">
              <Button onClick={handleCloseModal}>Cancel</Button>
              <Button 
                variant="contained" 
                onClick={handleSave} 
                disabled={
                  !hospitalName 
                  || hospitalName.length === 0
                  || !hospitalCountry
                  || hospital.length === 0
                }
              >
                {isNew ? 'Add Hospital' : 'Save Changes' }
              </Button>
            </Stack>
          </>
          :
          <Typography
            component="p"
            sx={{
              fontSize: '1.2em',
              textAlign: 'center',
              marginBottom: '8px',
            }}
          >
            Hospital data is unavailable!
          </Typography>
        }
      </Paper>
    </Modal>
  )
}

export default EditHospital